function MarketplaceOrderEditShippingStep() {
	return {
		fields: [
			'shippingStep.shippingAddress1',
			'shippingStep.shippingAddress2',
			'shippingStep.shippingAddress3',
			'shippingStep.shippingCoreCountry',
			'shippingStep.shippingCoreCountryState',
			'shippingStep.shippingPaid',
			'shippingStep.shippingCity',
			'shippingStep.currency',
			'shippingStep.shippingZipCode',
			'shippingStep.customerNote',
			'shippingStep.buyerName',
			'shippingStep.buyerEmail',
			'shippingStep.buyerPhone',
			'shippingStep.confirmationType',
			'shippingStep.useEnteredAddress',
			'shippingStep.useUpdatedAddress',
		],
		labels: {
			'shippingStep.shippingAddress1': 'MARKETPLACEORDEREDITFORM.SHIPPINGADDRESS1',
			'shippingStep.shippingAddress2': 'MARKETPLACEORDEREDITFORM.SHIPPINGADDRESS2',
			'shippingStep.shippingAddress3': 'MARKETPLACEORDEREDITFORM.SHIPPINGADDRESS3',
			'shippingStep.shippingCoreCountry': 'MARKETPLACEORDEREDITFORM.SHIPPINGCOUNTRY',
			'shippingStep.shippingCoreCountryState': 'MARKETPLACEORDEREDITFORM.SHIPPINGSTATE',
			'shippingStep.shippingPaid': 'MARKETPLACEORDEREDITFORM.SHIPPINGPAID',
			'shippingStep.shippingCity': 'MARKETPLACEORDEREDITFORM.SHIPPINGCITY',
			'shippingStep.shippingZipCode': 'MARKETPLACEORDEREDITFORM.SHIPPINGZIPCODE',
			'shippingStep.confirmationType': 'MARKETPLACEORDEREDITFORM.CONFIRMATIONTYPE',
			'shippingStep.buyerName': 'MARKETPLACEORDEREDITFORM.BUYERNAME',
			'shippingStep.buyerEmail': 'MARKETPLACEORDEREDITFORM.BUYEREMAIL',
			'shippingStep.buyerPhone': 'MARKETPLACEORDEREDITFORM.PHONE',
			'shippingStep.currency': 'MARKETPLACEORDEREDITFORM.CURRENCY',
			'shippingStep.customerNote': 'MARKETPLACEORDEREDITFORM.CUSTOMERNOTE',
		},
		rules: {
			'shippingStep.shippingAddress1': 'required',
			'shippingStep.shippingCoreCountry': 'required',
			'shippingStep.shippingCoreCountryState': 'required',
			'shippingStep.shippingCity': 'required',
			'shippingStep.shippingZipCode': 'required',
			'shippingStep.buyerName': 'required',
			'shippingStep.buyerEmail': 'email',
			'shippingStep.buyerPhone': 'required',
			'shippingStep.shippingPaid': 'numeric',
		},
	};
}

export default MarketplaceOrderEditShippingStep;



// WEBPACK FOOTER //
// ./src/modules/order/forms/wizard/MarketplaceOrderEditShippingStepForm.js